// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.border-list{
    border-bottom: 2px solid #80808014;
    padding: 0 0 4px;
    align-items: center;
   
}
.notes{
    font-size: 14px;
    font-weight: bolder;
    color: black;
}
.text-font{
    font-size: 15px;
    font-weight: 600;
    color: black;
}
.red-color{
    color: red;
    font-size: small;
}
.green{
    color: #093;
    font-size: 18px;
    font-weight: 600;
}
.plus {
    width: 12px;
    height: 12Upx;
    vertical-align: baseline;
}
.blacktext {
    font-size: 15px;
    font-weight: 600;
    font-family: Goldplay-bolder;
    color: black;
}
.green-button{
    background-color: #009933;
    width: 20%;
    font-size: 14px;
    border-radius: 5px;
    height: 35px;
}
.cursor-point{
    cursor: pointer;
    line-height: 20px;
    font-size: 13px !important;
    text-align: justify;
    font-family: 'Goldplay';
    
    text-shadow: 0 0 black;
}
.accordian-texts{
    color: white;
    padding-right: 20px;
    margin-bottom: 5px;
}
.todonav{
    font-weight: 600;
    border: none;
    gap: 30px;
    width: auto;
    padding: 2px 30px;
    font-size: 19px;
  }
  .checkbox-Updated {
    width: 15px !important;
    height: 15px !important;
}
  
.heighttodo{
      height: 42vh;
      overflow-x: hidden;
      position: relative;
  }
  /*sai priya css*/
  .mini-check .custm-checkbox {
    transform: scale(0.6);
  }
.post-time{
    font-size: 12px;
}
.bottom-border{
    border-bottom: 2px solid #80808014;
}
.img-preview-position{
    position: relative;
    width: 80px;
    height: 80px;
}
@media screen and (max-width:576px) {
    .notes{
        padding-left: 14px !important;
    }
    .minipost-due{
        font-size: 12px;
    }
    .img-preview-position {
        position: relative;
        width: 43px;
        height: 64px;
    }
}
.position-parent{
    position: relative;
}
.position-child{
    /* position: absolute;
    z-index: 99;
    top: 0;
    left: 520px; */
    display: none;
}
@media screen and (min-width:320px) and  (max-width:330px) {
    .todonav {
      padding-left: 6px !important;
       gap: 15px 18px !important;
       display: flex;
     }
  }
@media screen and (min-width:330px) and  (max-width:376px) {
    .todonav {
      padding-left: 6px !important;
       gap: 15px 35px !important;
       display: flex;
     }
  }
  @media screen and (min-width:376px) and (max-width:576px) {
    .todonav {
      padding-left: 6px !important;
       gap: 15px 18px !important;
       display: flex;
     }
  }`, "",{"version":3,"sources":["webpack://./src/Components/todos/minipost.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;;AAEvB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,aAAa;IACb,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;;IAEvB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;MACM,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;EACtB;EACA,gBAAgB;EAChB;IACE,qBAAqB;EACvB;AACF;IACI,eAAe;AACnB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI;QACI,6BAA6B;IACjC;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;IAChB;AACJ;AACA;IACI,kBAAkB;AACtB;AACA;IACI;;;kBAGc;IACd,aAAa;AACjB;AACA;IACI;MACE,4BAA4B;OAC3B,yBAAyB;OACzB,aAAa;KACf;EACH;AACF;IACI;MACE,4BAA4B;OAC3B,yBAAyB;OACzB,aAAa;KACf;EACH;EACA;IACE;MACE,4BAA4B;OAC3B,yBAAyB;OACzB,aAAa;KACf;EACH","sourcesContent":[".border-list{\n    border-bottom: 2px solid #80808014;\n    padding: 0 0 4px;\n    align-items: center;\n   \n}\n.notes{\n    font-size: 14px;\n    font-weight: bolder;\n    color: black;\n}\n.text-font{\n    font-size: 15px;\n    font-weight: 600;\n    color: black;\n}\n.red-color{\n    color: red;\n    font-size: small;\n}\n.green{\n    color: #093;\n    font-size: 18px;\n    font-weight: 600;\n}\n.plus {\n    width: 12px;\n    height: 12Upx;\n    vertical-align: baseline;\n}\n.blacktext {\n    font-size: 15px;\n    font-weight: 600;\n    font-family: Goldplay-bolder;\n    color: black;\n}\n.green-button{\n    background-color: #009933;\n    width: 20%;\n    font-size: 14px;\n    border-radius: 5px;\n    height: 35px;\n}\n.cursor-point{\n    cursor: pointer;\n    line-height: 20px;\n    font-size: 13px !important;\n    text-align: justify;\n    font-family: 'Goldplay';\n    \n    text-shadow: 0 0 black;\n}\n.accordian-texts{\n    color: white;\n    padding-right: 20px;\n    margin-bottom: 5px;\n}\n.todonav{\n    font-weight: 600;\n    border: none;\n    gap: 30px;\n    width: auto;\n    padding: 2px 30px;\n    font-size: 19px;\n  }\n  .checkbox-Updated {\n    width: 15px !important;\n    height: 15px !important;\n}\n  \n.heighttodo{\n      height: 42vh;\n      overflow-x: hidden;\n      position: relative;\n  }\n  /*sai priya css*/\n  .mini-check .custm-checkbox {\n    transform: scale(0.6);\n  }\n.post-time{\n    font-size: 12px;\n}\n.bottom-border{\n    border-bottom: 2px solid #80808014;\n}\n.img-preview-position{\n    position: relative;\n    width: 80px;\n    height: 80px;\n}\n@media screen and (max-width:576px) {\n    .notes{\n        padding-left: 14px !important;\n    }\n    .minipost-due{\n        font-size: 12px;\n    }\n    .img-preview-position {\n        position: relative;\n        width: 43px;\n        height: 64px;\n    }\n}\n.position-parent{\n    position: relative;\n}\n.position-child{\n    /* position: absolute;\n    z-index: 99;\n    top: 0;\n    left: 520px; */\n    display: none;\n}\n@media screen and (min-width:320px) and  (max-width:330px) {\n    .todonav {\n      padding-left: 6px !important;\n       gap: 15px 18px !important;\n       display: flex;\n     }\n  }\n@media screen and (min-width:330px) and  (max-width:376px) {\n    .todonav {\n      padding-left: 6px !important;\n       gap: 15px 35px !important;\n       display: flex;\n     }\n  }\n  @media screen and (min-width:376px) and (max-width:576px) {\n    .todonav {\n      padding-left: 6px !important;\n       gap: 15px 18px !important;\n       display: flex;\n     }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
